export const getSkills = () => [
	{
		name: "React",
		image: "react",
	},
	{
		name: "React Native",
		image: "react",
	},
	{
		name: "JavaScript",
		image: "javascript",
	},
	{
		name: "Node.js",
		image: "nodejs",
	},
	{
		name: "Bootstrap",
		image: "bootstrap",
	},
	{
		name: "Express",
		image: "express",
	},
	{
		name: "Chrome DevTools",
		image: "chrome",
	},
	{
		name: "CSS3",
		image: "css",
	},
	{
		name: "Git",
		image: "git",
	},
	{
		name: "GitHub",
		image: "github",
	},
	{
		name: "HTML5",
		image: "html",
	},
	{
		name: "jQuery",
		image: "jquery",
	},
	{
		name: "MongoDB",
		image: "mongo",
	},
	{
		name: "SASS",
		image: "sass",
	},
	{
		name: "TypeScript",
		image: "typescript",
	},
	{
		name: "SQL",
		image: "sql",
	},
	{
		name: "Visual Studio Code",
		image: "vscode",
	},
	{
		name: "Firebase",
		image: "firebase",
	},
	{
		name: "UI/UX",
		image: "figma",
	},
	{
		name: "Next.js",
		image: "nextjs",
	},
	{
		name: "Vue.js",
		image: "vue",
	},
	{
		name: "Neo4J",
		image: "neo4j",
	},
	{
		name: "PostgreSQL",
		image: "postgresql",
	},
	{
		name: "Tailwind",
		image: "tailwindcss",
	},
];
